// extracted by mini-css-extract-plugin
export default {"card__wrapper":"_5Db9aIpD","card__link-indicator":"_5D3G2ziI"};